/*
*
* File JS per la Single News
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroSingle from 'components/heroes/hero-single';
import blockTitle from 'components/block-title/block-title';
import blockText from 'components/block-text/block-text';
import blockCol2 from 'components/block-col2/block-col2';
import blockQuote from 'components/block-quote/block-quote';
import share from 'components/news/share';
import listNews from 'components/news/list-news';
import cardNews from 'components/news/card-news';
import cardTeam from 'components/team/card-team';


//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './single-news.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

window.addEventListener('DOMContentLoaded', (e) =>
{
    blockCol2();
});

//--------------------------------------------------------------------//